/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import PropTypes from 'prop-types';
import React from 'react';

// styles
import './styles/LoadingIndicator.scss';

const propTypes = {
  type: PropTypes.string,
  color: PropTypes.string,
  params: PropTypes.string,
};

const LoadingIndicator = ({ color, type, params }) => {
  const loadingStyleMapping = {
    spin: { name: 'la-ball-spin-clockwise', count: 8 },
    line: { name: 'la-line-scale', count: 5 },
    ball: { name: 'la-ball-fall', count: 3 },
    beat: { name: 'la-ball-beat', count: 3 },
  };

  let chosenType = loadingStyleMapping.spin;

  if (type in loadingStyleMapping) {
    chosenType = loadingStyleMapping[type];
  }

  const layoutFill = [];
  for (let i = 0; i < chosenType.count; i++) {
    layoutFill.push(<div key={i} />);
  }

  return (
    <div styleName="LoadingIndicator">
      <div
        styleName={chosenType.name + (params || '')}
        style={{ color, margin: 'auto' }}
      >
        {layoutFill}
      </div>
    </div>
  );
};

LoadingIndicator.propTypes = propTypes;

LoadingIndicator.defaultProps = {
  type: 'normal',
  color: '#23B4FF', // $blue-normal
};

export default LoadingIndicator;
